import React, { useState } from "react";
import cn from "classnames";
import styles from "./Subscription.module.sass";
import Icon from "../Icon";

const Subscription = ({ className, placeholder, onSuccess }) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    
    try {
      const response = await fetch('https://api.zovalife.co.uk/api/leads/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      if (response.ok) {
        setEmail('');
        setStatus("success");
        setMessage("Thank you for subscribing!");
        if (onSuccess) {
          onSuccess();
        }
        // Reset success message after 3 seconds
        setTimeout(() => {
          setStatus("idle");
          setMessage("");
        }, 3000);
      } else {
        setStatus("error");
        setMessage("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus("error");
      setMessage("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className={styles.wrapper}>
      <form
        className={cn(styles.form, className, {
          [styles.loading]: status === "loading",
          [styles.success]: status === "success",
          [styles.error]: status === "error"
        })}
        onSubmit={handleSubmit}
      >
        <input
          className={styles.input}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="email"
          placeholder={placeholder}
          required
          disabled={status === "loading"}
        />
        <button className={styles.btn} disabled={status === "loading"}>
          {status === "loading" ? (
            <Icon name="clock" size="14" />
          ) : (
            <Icon name="arrow-right" size="14" />
          )}
        </button>
      </form>
      {message && (
        <div className={cn(styles.message, {
          [styles.successMessage]: status === "success",
          [styles.errorMessage]: status === "error"
        })}>
          {message}
        </div>
      )}
    </div>
  );
};

export default Subscription;
